import { PAYMENT_STATUS } from "../constants"

// BookingTag color per payment status (upcoming-experience table)
export const PAYMENT_COLOR = {
  [PAYMENT_STATUS.paid]: "success",
  [PAYMENT_STATUS.partial]: "warning"
}

export const PAYMENT_LABEL = {
  [PAYMENT_STATUS.paid]: "Paid in Full",
  [PAYMENT_STATUS.partial]: "Balance Due"
}

// Maps a BookingTag color to the DollarSign stroke theme token
export const DOLLAR_STROKE_TOKEN = {
  success: "colorSuccess",
  warning: "colorWarning",
  error: "colorError"
}

// EditableTagCell: chips shown before the "+N more" overflow, and search debounce (ms)
export const VISIBLE_COUNT = 3
export const SEARCH_DELAY = 300
